import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const PhotoIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/photo"><path id="Icon" d="M20.75 15L17.4571 11.7071C17.0666 11.3166 16.4334 11.3166 16.0429 11.7071L13.75 14L9.51848 9.76848C9.1048 9.3548 8.42589 9.38304 8.04799 9.82965L3.25 15.5M14.15 7.9H14.158V7.908H14.15V7.9ZM14.55 7.9C14.55 8.12091 14.3709 8.3 14.15 8.3C13.9291 8.3 13.75 8.12091 13.75 7.9C13.75 7.67909 13.9291 7.5 14.15 7.5C14.3709 7.5 14.55 7.67909 14.55 7.9ZM4.75 20H19.25C20.0784 20 20.75 19.3284 20.75 18.5V5.5C20.75 4.67157 20.0784 4 19.25 4H4.75C3.92157 4 3.25 4.67157 3.25 5.5V18.5C3.25 19.3284 3.92157 20 4.75 20Z" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PhotoIcon;